"use client"

import { Type, User, Hash, X, Plus } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import $ from "jquery";

const __ = (key: string) => key;

const TextScreen = () => {

    const textChange = function (value: any) {
        (window as any).textBoxValue = value;
        $("#list-fonts-modal .font-preview").text(value);
    }

    return (
        <>
            <Card className="w-full border-none shadow-lg bg-card/85 backdrop-blur-sm h-full rounded-none">
                <CardHeader className="pb-3">
                    <CardTitle className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide text-foreground/80">
                        <Type className="h-4 w-4" />
                        <span className="lang" data-en="ADD TEXT" data-pt="ADICIONAR TEXTO" data-es="AÑADIR TEXTO">
                            {__('ADD TEXT')}
                        </span>
                    </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 p-4">
                    <p
                        id="txt-text-editor"
                        className="lang text-sm text-muted-foreground"
                        data-en="click on the point in the editor where you want to add the text"
                        data-pt="clique no ponto do editor onde deseja adicionar o texto"
                        data-es="Haga clic en el punto del editor donde desea agregar el texto."
                    >
                        {__('click on the point in the editor where you want to add the text')}
                    </p>
                    <div className="flex flex-wrap gap-2">
                        <Button
                            id="add-text-modal"
                            variant="outline"
                            size="sm"
                            className="lang gap-2 transition-all hover:bg-primary hover:text-secondary bg-secondary text-primary"
                            data-en="ADD NAME"
                            data-pt="ADICIONAR NOME"
                            data-es="AÑADIR NOMBRE"
                        >
                            <User className="h-4 w-4" />
                            {__('ADD NAME')}
                        </Button>
                        <Button
                            id="add-number-modal"
                            variant="outline"
                            size="sm"
                            className="lang gap-2 transition-all hover:bg-primary hover:text-secondary bg-secondary text-primary"
                            data-en="ADD NUMBER"
                            data-pt="ADICIONAR NÚMERO"
                            data-es="AÑADE UN NÚMERO"
                        >
                            <Hash className="h-4 w-4" />
                            {__('ADD NUMBER')}
                        </Button>
                    </div>
                </CardContent>
            </Card>

            <div
                id="modal-text-iframe"
                className="fixed inset-0 z-50 flex items-center justify-center bg-card/85 backdrop-blur-sm"
            >
                <Card className="w-[95%] max-w-md border-none shadow-2xl bg-card/85">
                    <CardContent className="p-6 space-y-4">
                        <Input
                            id="txt-input-iframe"
                            type="text"
                            placeholder="Digite o texto..."
                            className="w-full"
                            onChange={(e) => {
                                textChange(e.target.value)
                            }}
                        />
                        <div className="flex justify-end gap-2">
                            <Button
                                id="close-modal-text-iframe"
                                variant="outline"
                                size="sm"
                                className="lang gap-2 bg-transparent"
                                data-en="CANCEL"
                                data-pt="CANCELAR"
                                data-es="CANCELAR"
                            >
                                <X className="h-4 w-4" />
                                {__('CANCEL')}
                            </Button>
                            <Button
                                id="add-text-editor"
                                variant="default"
                                size="sm"
                                className="lang gap-2"
                                data-en="ADD"
                                data-pt="ADICIONAR"
                                data-es="PARA AÑADIR"
                            >
                                <Plus className="h-4 w-4" />
                                {__('ADD')}
                            </Button>
                        </div>
                        <div id="list-fonts-modal" className='w-full grid gap-3 grid-cols-3 bg-secondary p-2 rounded-lg h-[calc(100vh-200px)] overflow-y-auto'>
                            <div title='aArigatouGozaimasu' data-path="fonts/" data-extension="ttf" className="font7 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="aArigatouGozaimasu">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">aArigatouGozaimasu</span>
                            </div>
                            <div title='AURORA-Regular' data-path="fonts/" data-extension="ttf" className="font13 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="AURORA-Regular">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">AURORA-Regular</span>
                            </div>
                            <div title='BrazierFlame' data-path="fonts/" data-extension="ttf" className="font16 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="BrazierFlame">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">BrazierFlame</span>
                            </div>
                            <div title='Catamaran' data-path="fonts/" data-extension="ttf" className="font18 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="Catamaran">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Catamaran</span>
                            </div>
                            <div title='Coconut House' data-path="fonts/" data-extension="ttf" className="font19 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="Coconut House">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Coconut House</span>
                            </div>
                            <div title='KawitFree-CndItalic' data-path="fonts/" data-extension="ttf" className="font23 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="KawitFree-CndItalic">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">KawitFree-CndItalic</span>
                            </div>
                            <div title='Lavindir' data-path="fonts/" data-extension="ttf" className="font24 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="Lavindir">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Lavindir</span>
                            </div>
                            <div title='LTBulletin-Medium' data-path="fonts/" data-extension="ttf" className="font25 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="LTBulletin-Medium">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">LTBulletin-Medium</span>
                            </div>
                            <div title='MakerVan-Regular' data-path="fonts/" data-extension="ttf" className="font27 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="MakerVan-Regular">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">MakerVan-Regular</span>
                            </div>
                            <div title='NCS Rogueland Slab Bold' data-path="fonts/" data-extension="ttf" className="font28 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="NCS Rogueland Slab Bold">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">NCS Rogueland Slab</span>
                            </div>
                            <div title='Number9' data-path="fonts/" data-extension="ttf" className="font29 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="Number9">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Number9</span>
                            </div>
                            <div title='Shock' data-path="fonts/" data-extension="ttf" className="font32 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="Shock">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Shock</span>
                            </div>
                            <div title='Talisman' data-path="fonts/" data-extension="ttf" className="font33 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="Talisman">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Talisman</span>
                            </div>
                            <div title='teefont' data-path="fonts/" data-extension="ttf" className="font34 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="teefont">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">teefont</span>
                            </div>
                            <div title='BEST-IN-CLASS' data-path="fonts/fontsFutebol/" data-extension="ttf" className="font37 flex flex-col items-center justify-center p-3 rounded-md border hover:bg-primary hover:text-background cursor-pointer transition-colors gap-1" data-value="BEST-IN-CLASS">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">BEST-IN-CLASS</span>
                            </div>
                            <div title='Fut-1' data-path="fonts/fontsFutebol/" data-extension="ttf" className="font39 flex flex-col items-center justify-center p-3 rounded-md border cursor-pointer transition-colors hover:bg-primary hover:text-background gap-1" data-value="Fut-1">
                                <span className="text-[28px] leading-none font-preview">25</span>
                                <span className="text-[9px] opacity-60 truncate w-full text-center mt-1">Fut-1</span>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </>
    );
}

export default TextScreen;
